import moment from 'moment-timezone'

import 'moment/locale/pt-br'

moment.locale('pt-br')

export function getCurrentMonthRange() {
  let today = new Date();
  today.setHours(0, 0, 0, 0);

  return {
    startDate: new Date(today.getFullYear(), today.getMonth(), 1),
    endDate: new Date(today.getFullYear(), today.getMonth() + 1, 0),
  }
}

export function formatDateISO(value) {
  if (!value) return null

  return moment(value).format('YYYY-MM-DD');
}

export function formatDateBR(value) {
  if (!value) return 'Data não informada';

  return moment(value).tz('America/Sao_Paulo').format('DD/MM/YYYY');
}

export function formatDateTimeBR(value) {
  if (!value) return 'Data não informada';

  return moment(value).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm');
}

export function formatDateLongBR(value) {
  if (!value) return 'Data não informada';

  return moment(value).tz('America/Sao_Paulo').format('D [de] MMMM [de] YYYY [às] HH:mm');
}

export function formatDateTimeShortBR(value) {
  if (!value) return 'Data não informada';

  return moment(value).tz('America/Sao_Paulo').format('DD/MM/YY [às] HH:mm');
}
